import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NoticePage() {
  const { t } = useI18n();
  const [notices, setNotices] = useState([]);
  useEffect(() => { axios.get(`${API}/notices`).then((r) => setNotices(r.data || [])).catch(() => {}); }, []);

  return (
    <div className="pt-28 md:pt-36 pb-20 bg-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-20">
          <div className="md:col-span-5">
            <div className="label-eyebrow mb-3">{t.notice.eyebrow}</div>
            <h1 className="font-display font-medium text-slate-900 text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight">{t.notice.title}</h1>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-slate-600 text-lg leading-relaxed">{t.notice.sub}</p>
          </div>
        </div>

        <div className="space-y-4">
          {notices.map((n, i) => (
            <motion.article
              key={n.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              data-testid={`notice-${n.id}`}
              className="card-hover grid grid-cols-1 md:grid-cols-12 gap-5 p-6 md:p-8 border border-slate-200 rounded-xl bg-white"
            >
            
      
      
      
               <div className="md:col-span-9">
                <h2 className="font-display text-slate-900 text-2xl md:text-3xl leading-tight tracking-tight mb-3">{n.title}</h2>
                <p className="text-slate-600 leading-relaxed">{n.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
}
